import React, { memo } from 'react'
import { VehicleInsuranceForm } from 'src/components/vehicle-insurance/VehicleInsuranceForm'
import { Driver } from 'src/interfaces/driver'

interface Props {
  driver?: Driver
}

const VehicleInsuranceComponent = ({ driver }: Props) => {
  return <VehicleInsuranceForm driver={driver} />
}

export const VehicleInsurance = memo(VehicleInsuranceComponent)
